import axios, { AxiosError, AxiosInstance } from 'axios';

type SignOut = () => void;

type PromiseType = {
  onSuccess: (token: string) => void;
  onFailure: (error: AxiosError) => void;
};

type APIInstanceProrps = AxiosInstance & {
  registerInterceptTokenManager: (signOut: SignOut) => () => void;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // baseURL: 'http://localhost:3335',
  // baseURL: 'https://apiv2.getap.agr.br',
  withCredentials: true,
}) as APIInstanceProrps;

let failedQueue: Array<PromiseType> = [];
let isRefreshing = false;

api.registerInterceptTokenManager = (signOut) => {
  const interceptTokenManager = api.interceptors.response.use(
    (response) => response,
    async (requestError) => {
      if (requestError?.response?.status === 401) {
        const message = requestError.response.data?.message;

        console.log('DENTRO DO INTERCEPTOR', message);

        if (message === 'Token ausente' || message === 'token.invalid') {
          const originalRequestConfig = requestError.config;

          if (isRefreshing) {
            return new Promise((resolve, reject) => {
              failedQueue.push({
                onSuccess: (token: string) => {
                  originalRequestConfig.headers = {
                    ...originalRequestConfig.headers,
                    Authorization: `Bearer ${token}`,
                  };
                  resolve(api(originalRequestConfig));
                },
                onFailure: (error: AxiosError) => {
                  reject(error);
                },
              });
            });
          }

          isRefreshing = true;

          return new Promise(async (resolve, reject) => {
            try {
              const { data } = await api.post('/sessions/refreshtoken');

              if (
                originalRequestConfig.data &&
                typeof originalRequestConfig.data === 'string'
              ) {
                try {
                  originalRequestConfig.data = JSON.parse(
                    originalRequestConfig.data
                  );
                } catch (e) {
                  // Se não for JSON, ignora
                }
              }

              originalRequestConfig.headers = {
                ...originalRequestConfig.headers,
                Authorization: `Bearer ${data.token}`,
              };

              api.defaults.headers.common[
                'Authorization'
              ] = `Bearer ${data.token}`;

              failedQueue.forEach((request) => {
                request.onSuccess(data.token);
              });

              resolve(api(originalRequestConfig));
            } catch (error: any) {
              failedQueue.forEach((request) => {
                request.onFailure(error);
              });
              signOut();
              reject(error);
            } finally {
              isRefreshing = false;
              failedQueue = [];
            }
          });
        }

        signOut();
      }

      if (requestError.response && requestError.response.data) {
        return Promise.reject(
          new Error(
            requestError.response.data.message || 'Erro inesperado no servidor'
          )
        );
      }

      return Promise.reject(requestError);
    }
  );

  return () => {
    api.interceptors.response.eject(interceptTokenManager);
  };
};

export const cepApi = axios.create({
  baseURL: ' https://brasilapi.com.br/api/cep/v1',
});

export default api;
